import { Home, User } from "lucide-react"

export const COLOR_PRESETS = [
  '#E95F56', '#F2A63B', '#47B881', '#3B82F6', '#06B6D4',
  '#8B5CF6', '#EC4899', '#14B8A6', '#6366F1', '#F97316',
  '#D946EF', '#64748B', '#A855F7', '#EAB308', '#78716C',
] as const

export const DEFAULT_CATEGORY_COLOR = '#78716C'
export const UNCATEGORIZED_LABEL = '未分類'
export const MS_PER_DAY = 86_400_000

export const BUDGET_SCOPE = {
  household: { label: "家計", Icon: Home },
  personal: { label: "個人", Icon: User },
} as const
